<template>
  <div class="w-full md:w-2/3 mt-4 md:mt-0 md:pl-8">
    <div
      class="w-full h-full padding--x chatbot__container py-4 md:pt-6 md:pb-4"
    >
      <VueBotUI
        :is-open="true"
        :messages="messages"
        :options="{
          colorScheme: 'rgb(242, 194, 68)',
          botTitle: this.chatBot.name,
          botAvatarImg: '/alfred.png',
        }"
        @msg-send="messageSendHandler"
        :bot-typing="isTyping"
      />
    </div>
  </div>
</template>

<script>
import { VueBotUI } from "vue-bot-ui";
import { fetchEventSource } from "@microsoft/fetch-event-source";

export default {
  name: "ChatBotMessages",
  components: {
    VueBotUI,
  },
  props: {
    chatBot: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isTyping: false,
      pending: "",
    };
  },
  computed: {
    messages() {
      return this.chatBot.messages.map((x) => {
        return {
          agent: x.role === "user" ? "user" : "bot",
          type: "text",
          text: x.content,
        };
      });
    },
  },
  methods: {
    async messageSendHandler(input) {
      const { text } = input;
      const url = "https://agent.neolen.xyz/api/chatbot/answer";
      const headers = {
        "Content-Type": "application/json",
      };
      const data = {
        question: text,
        messages: this.chatBot.messages.map((message, index) => {
          return {
            key: index,
            data: message.content,
          };
        }),
        id: this.chatBot._id,
        model: this.chatBot.model,
      };

      // create new message and start typing
      // eslint-disable-next-line no-unused-vars
      let cancelToken;

      this.chatBot.messages.push({ role: "user", content: text });
      this.chatBot.messages.push({ role: "assistant", content: "" });

      const ctrl = new AbortController();

      try {
        fetchEventSource(url, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(data),
          signal: ctrl.signal,
          onmessage: (event) => {
            if (event.data === "[DONE]") {
              this.pending = "";
              ctrl.abort();
            } else {
              const data = JSON.parse(event.data);
              if (data.sourceDocs) {
                console.log("*** whole text", data.sourceDocs);
              } else {
                this.pending = this.pending + data.data;
                let current_messages = this.chatBot.messages;
                current_messages[current_messages.length - 1].content =
                  this.pending;
              }
            }
          },
        });
      } catch (error) {
        alert("An error occurred while fetching the data. Please try again.");
        console.log("error", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.common {
  &__box {
    padding: 2em;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0px 30px 40px 20px rgba(99, 132, 227, 0.1);
  }
}

.chatbot {
  &__container {
    background: #ffffff;
    display: flex;
    border-radius: 10px;

    flex-direction: column;
    align-items: center;
    //justify-content: center;
  }
}
.card {
  width: 50vh;
  height: 70vh;
  top: 100px;
  background: #ffffff;
  box-shadow: 0px 40px 50px 30px rgba(99, 132, 227, 0.1);
  border-radius: 12px;
  margin: 3em 0;

  &__icon {
    width: 5em;
    height: 5em;
    border-radius: 50px;
  }
  &__name {
    font-size: 1em;
    font-weight: 900;
    color: black;
  }
  &__status {
    margin-top: -8px;
    font-size: 0.8em;
    margin-left: 5px;
  }

  &__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: rgb(32, 190, 32);
  }
  &__line {
    height: 1px;
    width: 100%;
    background-color: rgb(236, 234, 234);
  }
  &__text {
    font-size: 1em;
    padding: 0.5em;
    color: black;
    font-weight: 600;
    border-radius: 20px;
    box-shadow: 10px 5px 5px rgba(99, 132, 227, 0.1);
  }
}

.loader {
  margin-top: 8px;
  display: flex;
  align-items: center;
  &__bubble {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    margin-right: 6px;

    &:nth-child(4) {
      background-color: #e8750c;
    }
    &:nth-child(3) {
      background-color: #ff0000;
    }
    &:nth-child(2) {
      background-color: #9c0ce8;
    }
    &:nth-child(1) {
      background-color: #2153f9;
    }
  }
}
p {
  font-size: 1em;
}
.card2 {
  width: 50vh;
  border-radius: 12px;
}
.cross {
  margin-top: -20px;
  width: 3em;
  height: 3em;
  font-size: 1.2em;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0px 40px 50px 30px rgba(92, 127, 230, 0.1);
}

@media only screen and (max-width: 768px) {
  .chatbot__container {
    background: transparent;
  }
}

@media only screen and (max-width: 746px) {
  .card {
    &__icon {
      width: 3em;
      height: 3em;
      border-radius: 50px;
    }
    &__name {
      font-size: 0.8em;
      font-weight: 900;
    }
    &__text {
      font-size: 0.9em;
      padding: 0.5em;
    }
  }

  .loader {
    .bubble {
      &__text {
        font-size: 0.8em;
      }
    }
  }
  .cross {
    width: 2em;
    height: 2em;
    font-size: 1em;
  }
}
</style>

<style>
.qkb-bot-ui {
  bottom: 5%;
  right: 10%;
}
.qkb-board {
  width: 30vw;
  min-width: 300px;
  height: 70vh;
}

@media only screen and (max-width: 768px) {
  .qkb-bot-ui {
    bottom: 5%;
    right: 5%;
  }
}
</style>
